/* @flow */
import { ActionTypes } from 'constants/DeviceConstants';
import Store from 'lib/Store';
import Device from 'entities/Device';
import Devices from 'collections/Devices';
import DeviceActions from 'actions/DeviceActions';
import { PushEvents } from 'pusher/PusherConstants';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class DeviceStore extends Store {
  getInitialState() {
    return {
      loaded: false,
      devices: new Devices(),
    };
  }

  isLoaded(): boolean {
    return this.state.loaded;
  }

  getDevices(): Devices {
    return this.state.devices;
  }

  getDevice(deviceId: any): Device {
    return this.state.devices.get(deviceId);
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case PushEvents.CHANGESET_UPDATE_DEVICE:
      case PushEvents.CHANGESET_CREATE_DEVICE: {
        const ids = action.changes.map(change => change.id);
        DeviceActions.loadDevices(ids);
        break;
      }
      case PushEvents.CHANGESET_DESTROY_DEVICE: {
        const ids = action.changes.map(change => change.id);
        this.state.devices.remove(ids);
        this.emitChange();
        break;
      }
      case ActionTypes.LOAD_DEVICES:
        this.state.devices.add(action.devices);
        this.state.loaded = action.all;
        this.emitChange();
        break;
      case ActionTypes.UPDATE_DEVICE:
        this.state.devices.set([action.device], { remove: false });
        this.emitChange();
        break;
      case ActionTypes.DELETE_ALL_DEVICES:
        this.resetState();
        this.emitChange();
        break;
      case ActionTypes.DELETE_DEVICE:
        this.state.devices.remove(action.device.id);
        this.emitChange();
        break;
      case ActionTypes.CREATE_DEVICE:
        this.state.devices.push(action.device);
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new DeviceStore();
